module.exports = __webpack_public_path__ + "img/IMG_0675.54da1b71.jpg";